/* unplugin-vue-components disabled */import script from "./course-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./course-modal.vue?vue&type=script&setup=true&lang=js"

import "./course-modal.vue?vue&type=style&index=0&id=4698759b&lang=scss"

const __exports__ = script;

export default __exports__